import { createAsyncThunk } from "@reduxjs/toolkit"
import { axios_api } from "../../../api/axios-api"
import { IQueryParams, getSearchQuery } from "../../../common"
import { IPaymentGateway } from "./payment-gateway.types"
import { uploadSingleFileAsync } from "../../../helpers/uploadFilesAsync"
import { closeLoaderWithMessage, openLoaderWithMessage } from "../../common"
import { createAsyncThunkPostWrapper } from "../../store.wrapper"
import { defaultPaymentGateway } from "./payment-gateway.state"
import { server_base_endpoints } from "../../../api"


export const fetchMultiplePaymentGatewayAsync = createAsyncThunk<{ data: IPaymentGateway[], count: number }, IQueryParams>(
    'payment-gateway/fetchMultiplePaymentGatewayAsync', async (queryParams: IQueryParams) => {
        const searchQuery = getSearchQuery(queryParams);
        const response = await axios_api.get(`${server_base_endpoints.settings.payment_gateway.get_payment_gateway}${searchQuery}`)
        return response.data as { data: IPaymentGateway[], count: number }
    },
)

export const fetchSinglePaymentGatewayAsync = createAsyncThunk<IPaymentGateway, string>(
    'payment-gateway/fetchSinglePaymentGatewayAsync', async (uuid: string, thunkAPI) => {
        const response = await axios_api.get(`${server_base_endpoints.settings.payment_gateway.get_payment_gateway}?outlet_uuid=${uuid}`)
        return response.data?.data?.length > 0 ? response.data?.data[0] : defaultPaymentGateway
    },
)

interface IUpsertPaymentGateway {
    payload: IPaymentGateway
    onCallback: (isSuccess: boolean, response: IPaymentGateway) => void
}

export const upsertSinglePaymentGatewayAsync = createAsyncThunkPostWrapper<IPaymentGateway, IUpsertPaymentGateway>(
    'payment-gateway/upsertSinglePaymentGatewayAsync', async ({ payload, onCallback }, thunkAPI) => {
        const { create_ts, insert_ts, ...restPayload } = payload
        thunkAPI.dispatch(openLoaderWithMessage("Saving Changes..!"))
        const response = await axios_api.post(server_base_endpoints.settings.payment_gateway.upsert_payment_gateway, restPayload)
        onCallback(true, response.data.data)
        return thunkAPI.fulfillWithValue(response.data)
    },
)


